import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';

/**
 * @param {object} props
 * @param {string[]} props.variables
 */
const SelectedVariablesChip = ({ variables }) => {
    const variablesCount = variables.length;

    if (variablesCount === 0) {
        return null;
    }

    const label = variables[0];

    const tooltipContent =
        variablesCount > 1 ? (
            <div>
                {variables.map((v, idx) => (
                    <div key={idx}>{v}</div>
                ))}
            </div>
        ) : (
            label
        );

    return (
        <Tooltip
            placement="bottom"
            mouseEnterDelay={0.1}
            mouseLeaveDelay={0}
            overlay={tooltipContent}
        >
            <div className="data-browser-group__chip flex-it">
                <div className="data-browser-group__chip__label">{label}</div>
                {variablesCount > 1 && <div>+{variablesCount - 1}</div>}
            </div>
        </Tooltip>
    );
};

SelectedVariablesChip.propTypes = {
    variables: PropTypes.array,
};

SelectedVariablesChip.defaultProps = {
    variables: [],
};

export default SelectedVariablesChip;
